module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4x.eebb4e4c.jpg";